export const contactsData = {
    email: 'vinodkumar9576@gmail.com',
    phone: '+91 8210478225',
    address: 'Marathahalli, Bengaluru, Karnataka, India - 560037 ',

    sheetAPI: 'https://sheetdb.io/api/v1/0de1lw2cggy8l'
}